import { FC, PropsWithChildren } from 'react';

const Headline: FC<PropsWithChildren<{ 
  description?: string,
  size?: 'small' | 'medium' | 'large',
  upperCase?: boolean,
}>> = ({ 
  children,
  description,
  size = 'medium',
  upperCase = false,
}) => (
  <div className="">
    <h2 className={`
       tracking-wide
      ${{
        small:  'text-sm',
        medium: 'text-lg',
        large:  'text-xl',      
      }[size]}`
    }>
      {upperCase && children
        ? children?.toString()?.toUpperCase()
        : children
      }
    </h2>
    {!!description && (
      <div>{description}</div>
    )}
  </div>
);

export default Headline;
